// @flow
export const ROUTE = 'upgrade/ROUTE';
export const route = (query?: Object) => ({
  type: ROUTE,
  meta: {
    query,
  },
});
